import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { HEATMAP_DAYS } from 'constants/heatmap';
import { bem } from 'helpers/class-name';

import { DayHourHeatmapTableHead } from './DayHourHeatmap.helpers';

import './DayHourHeatmap.scss';

const { element } = bem('day-hour-heatmap');

const defaultRenderEmptyCell = () => <div className={element('empty-cell')}>&nbsp;</div>;

function DayHourHeatmapPlaceholder({
  className,
  dayHeaders,
  timeLabels,
  pulse = false,
  staticGrid = false,
  renderEmptyCell = defaultRenderEmptyCell,
  testId,
}) {
  return (
    <table
      className={classNames(element('table', { placeholder: true, static: staticGrid, pulse }), className)}
      data-testid={testId}>
      <DayHourHeatmapTableHead dayHeaders={dayHeaders} />
      <tbody>
        {timeLabels.map((time, rowIndex) => (
          <tr key={time} style={pulse && !staticGrid ? { animationDelay: `${rowIndex * 0.2}s` } : undefined}>
            <th scope="row">{time}</th>
            {HEATMAP_DAYS.map(dayKey => (
              <td key={`${time}-${dayKey}`}>{renderEmptyCell(time, dayKey)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

DayHourHeatmapPlaceholder.propTypes = {
  className: PropTypes.string,
  dayHeaders: PropTypes.arrayOf(PropTypes.node),
  timeLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  pulse: PropTypes.bool,
  staticGrid: PropTypes.bool,
  renderEmptyCell: PropTypes.func,
  testId: PropTypes.string,
};

export default DayHourHeatmapPlaceholder;
